import updateQuery from 'gleam-shared/network/updateQuery'

window.updateQuery = updateQuery
